// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TCul","right":"styles_right__29ckL"};